import { toast } from 'react-toastify';
import convertToQueryString from 'helpers/query';

const successHandler = async (result, store, returnErrors = false) => {
  const { status, headers } = result;

  const response = headers.has('X-File')
    ? await result.blob()
    : await result.json();

  const toastId = status === 401
    ? '401'
    : undefined;

  const toastConfig = { toastId };

  if (response && response.message) {
    if (Array.isArray(response.message)) {
      response.message.forEach(message => toast[response.toast || 'success']((message || '').trim(), toastConfig));
    } else {
      toast[response.toast || 'success']((response.message || '').trim(), toastConfig);
    }
  }

  if (status === 401) {
    store.setUser(null);
    localStorage.removeItem('user');
  }

  if (status === 200) return response;
  return returnErrors ? { ...response, __httpError: true } : null;
};

export default class Service {
  apiUrl = process.env.API_URL || 'http://localhost:3000/api';

  defineCredentials = {
    credentials: 'include',
  };

  defineHeaders = {
    headers: {
      'Content-Type': 'application/json',
    },
  }

  constructor(store) {
    this.store = store;
  }

  async getResource(url, query = {}) {
    const result = await fetch(`${this.apiUrl}${url}${convertToQueryString(query)}`, {
      method: 'GET',
      ...this.defineHeaders,
      ...this.defineCredentials,
    });
    return await successHandler(result, this.store);
  }

  async postFormData(url, formData) {
    const result = await fetch(`${this.apiUrl}${url}`, {
      method: 'POST',
      body: formData,
      ...this.defineCredentials,
    });
    return await successHandler(result, this.store);
  }

  async postResource(url, body = {}, options = {}) {
    const result = await fetch(`${this.apiUrl}${url}`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...this.defineHeaders,
      ...this.defineCredentials,
    });
    return await successHandler(result, this.store, options.returnErrors);
  }

  async putResource(url, body = {}, options = {}) {
    const result = await fetch(`${this.apiUrl}${url}`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...this.defineHeaders,
      ...this.defineCredentials,
    });
    return await successHandler(result, this.store, options.returnErrors);
  }

  async deleteResource(url, body = {}) {
    const result = await fetch(`${this.apiUrl}${url}`, {
      method: 'DELETE',
      body: JSON.stringify(body),
      ...this.defineHeaders,
      ...this.defineCredentials,
    });
    return await successHandler(result, this.store);
  }
}
